import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { nomeCompleto } from "@/lib/format";
import { toast } from "sonner";
import { Plus, Loader2, Check, UserRoundPlus } from "lucide-react";

export default function ReferenteSelect({ value, onChange, testid = "referente-select" }) {
  const qc = useQueryClient();
  const { data: referenti } = useQuery({ queryKey: ["referenti"], queryFn: async () => (await api.get("/referenti")).data });
  const [adding, setAdding] = useState(false);
  const [f, setF] = useState({ nome: "", cognome: "", telefono: "", email: "" });
  const [busy, setBusy] = useState(false);

  const save = async () => {
    if (!f.nome.trim() || !f.telefono.trim()) return toast.error("Nome e telefono sono obbligatori");
    setBusy(true);
    try {
      const { data } = await api.post("/referenti", f);
      await qc.invalidateQueries({ queryKey: ["referenti"] });
      onChange(data.id);
      setAdding(false); setF({ nome: "", cognome: "", telefono: "", email: "" });
      toast.success("Referente creato");
    } catch (e) { toast.error(e?.response?.data?.detail || "Errore"); }
    finally { setBusy(false); }
  };

  const inp = "w-full px-2.5 py-1.5 text-sm bg-white border border-[#1A2B4A]/20 rounded-sm focus:outline-none focus:border-[#C9A84C]";

  return (
    <div className="rounded-lg border border-[#1A2B4A]/15 bg-white p-4">
      <div className="flex items-center gap-2 mb-3">
        <UserRoundPlus className="w-4 h-4 text-[#C9A84C]" />
        <h4 className="text-[11px] font-semibold uppercase tracking-[0.12em] text-[#1A2B4A]">Rif.</h4>
      </div>
      <div className="flex gap-2">
        <select data-testid={testid} value={value || ""} onChange={(e) => onChange(e.target.value || null)} className={inp}>
          <option value="">RB Studio (predefinito)</option>
          {(referenti || []).map((r) => (
            <option key={r.id} value={r.id}>{nomeCompleto(r)} · {r.telefono}</option>
          ))}
        </select>
        <button type="button" data-testid={`${testid}-new`} onClick={() => setAdding((v) => !v)}
          className="shrink-0 inline-flex items-center gap-1 text-xs border border-[#1A2B4A]/20 px-2.5 rounded-sm hover:border-[#C9A84C] whitespace-nowrap">
          <Plus className="w-3.5 h-3.5" /> Nuovo
        </button>
      </div>
      <p className="text-[11px] text-[#4a5568] mt-1.5">In assenza di referente viene attribuito automaticamente a RB Studio.</p>

      {adding && (
        <div className="mt-3 border-t border-[#1A2B4A]/10 pt-3 grid sm:grid-cols-2 gap-x-3 gap-y-2">
          <div><label className="text-[11px] text-[#4a5568]">Nome *</label>
            <input data-testid="ref-new-nome" value={f.nome} onChange={(e) => setF({ ...f, nome: e.target.value })} className={inp} /></div>
          <div><label className="text-[11px] text-[#4a5568]">Cognome</label>
            <input data-testid="ref-new-cognome" value={f.cognome} onChange={(e) => setF({ ...f, cognome: e.target.value })} className={inp} /></div>
          <div><label className="text-[11px] text-[#4a5568]">Telefono *</label>
            <input data-testid="ref-new-telefono" value={f.telefono} onChange={(e) => setF({ ...f, telefono: e.target.value })} className={inp} /></div>
          <div><label className="text-[11px] text-[#4a5568]">Email</label>
            <input data-testid="ref-new-email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className={inp} /></div>
          <div className="sm:col-span-2 flex justify-end">
            <button type="button" data-testid="ref-new-save" onClick={save} disabled={busy}
              className="inline-flex items-center gap-1.5 text-xs bg-[#1A2B4A] text-white px-3 py-1.5 rounded-sm hover:bg-[#22345c] disabled:opacity-50">
              {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Check className="w-3.5 h-3.5" />} Salva referente
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
